import { createContext } from "react";

// Set inside touch-layout drawers so RemiButton grows to a 44px target there and nowhere else on the page.
export const TouchTargetsContext = createContext(false);
